import { render, staticRenderFns } from "./ContentSidebarLayout.vue?vue&type=template&id=6df8cdc1&scoped=true&"
import script from "./ContentSidebarLayout.vue?vue&type=script&lang=js&"
export * from "./ContentSidebarLayout.vue?vue&type=script&lang=js&"
import style0 from "./ContentSidebarLayout.vue?vue&type=style&index=0&id=6df8cdc1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df8cdc1",
  null
  
)

export default component.exports